import React from "react";
const DownloadIcon = () => {
  return (
    <svg width="41.712" height="41.712" xmlns="http://www.w3.org/2000/svg">
      <rect
        fill="none"
        id="canvas_background"
        height="402"
        width="582"
        y="-1"
        x="-1"
      />
      <g>
        <path
          id="svg_1"
          fill="#FFF"
          d="m31.586,21.8c0.444,-0.444 0.444,-1.143 0,-1.587c-0.429,-0.444 -1.143,-0.444 -1.571,0l-8.047,8.032l0,-26.539c0,-0.619 -0.492,-1.127 -1.111,-1.127c-0.619,0 -1.127,0.508 -1.127,1.127l0,26.539l-8.031,-8.032c-0.444,-0.444 -1.159,-0.444 -1.587,0c-0.444,0.444 -0.444,1.143 0,1.587l9.952,9.952c0.429,0.429 1.143,0.429 1.587,0l9.935,-9.952zm7.888,7.286c0,-0.619 0.492,-1.111 1.111,-1.111c0.619,0 1.127,0.492 1.127,1.111l0,10.92c0,0.619 -0.508,1.127 -1.127,1.127l-39.474,0c-0.619,0 -1.111,-0.508 -1.111,-1.127l0,-10.92c0,-0.619 0.492,-1.111 1.111,-1.111s1.127,0.492 1.127,1.111l0,9.809l37.236,0l0,-9.809z"
        />
      </g>
    </svg>
  );
};

export default DownloadIcon;



// WEBPACK FOOTER //
// ./src/components/DownloadIcon.js